<template>
  <div class="buy">
    <Header :navIndex="navIndex"></Header>
    <div class="intro">
      <div class="left">
        <img class="line" src="../assets/index/line.png" alt="" />
        <div class="title">{{ title }}</div>
      </div>
    </div>
    <div class="btm">
      <div class="btmD">
        <div class="jianjie" v-html="desc"></div>
        <div class="itemWrap">
          <div class="item">
            <img class="itemnum" :src="`${image1}`" alt="" />
            <div class="itemTitle">{{ image1_title }}</div>
          </div>
          <!--                    <div class="item">-->
          <!--                        <img class="itemnum" src="../assets/anli/qiqian.png" alt="">-->
          <!--                        <div class="itemTitle">安装成窗共计70000+</div>-->
          <!--                    </div>-->
          <div class="item" style="border-right: unset">
            <img class="itemnum" :src="`${image2}`" alt="" />
            <div class="itemTitle">{{ image2_title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="intro" style="margin-top: 5rem">
      <div class="left">
        <img class="line" src="../assets/index/line.png" alt="" />
        <div class="title">案例展示</div>
      </div>
    </div>

    <!-- 图片列表 -->
    <div class="imgWrap">
      <div v-for="(item, index) in list" :key="index">
        <!-- @click="toDetail(item, mark[item - 1])" -->

        <!-- v-if="flag ? item <= total : item < 10" -->
        <!-- :style="{ marginLeft: item == total ? '0' : '0rem' }" -->
        <div
          @click="toDetail(item, item.id)"
          class="pic"
          @mouseover="showMark = item.title"
          @mouseleave="showMark = ''"
        >
          <img :src="item.image" alt="" />
          <div
            class="mark animate__fadeIn animate__animated"
            v-if="showMark == item.title"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <!-- 显示更多 -->
    <div class="back" @click="upDrop">{{ btn }}</div>
    <Part5></Part5>
  </div>
</template>

<script>
import Header from "../components/Header";
import { casesIndex, cases, casesDetail } from "../api/request";
import Part5 from "../components/Part5";
export default {
  components: { Header, Part5 },
  name: "anli",
  data() {
    return {
      total: 0,
      showMark: "",
      list: [],
      // mark: [
      //   "山东德州扒鸡集团",
      //   "莆田翁氏府邸",
      //   "奥利维亚",
      //   "哈公馆",
      //   "盛和天下",
      //   "翠湖天地",
      //   "保利小区",
      //   "观江国际",
      //   "世纪花园",
      //   "碧水庄园",
      //   "辰能溪树庭院",
      //   "观复国际",
      //   "海富山水文园 ",
      //   "华侨丽景",
      //   "龙之港",
      //   "盟科时代",
      // ],
      flag: false,
      btn: "显示更多",
      navIndex: 6,

      desc: "",
      image1: null,
      image2: null,
      image1_title: "",
      image2_title: "",
      title: "",
    };
  },
  mounted() {
    // 案例上部分
    casesIndex().then((res) => {
      if (res.data.code == 1) {
        console.log(res.data.data);

        var obj = res.data.data;
        this.desc = obj.desc;
        this.image1 = obj.image1;
        this.image2 = obj.image2;
        this.image1_title = obj.image1_title;
        this.image2_title = obj.image2_title;
        this.title = obj.title;
      }
    });

    // 案例图展示  初始展示9个  点按钮展示所有
    this.getList();
  },
  methods: {
    // 进入详情轮播图
    toDetail(item, id) {
      // console.log(item);
      // console.log(id);

      casesDetail({ id: id }).then((res) => {
        if (res.data.code == 1) {
          // console.log(res.data.data);
          // res.data.data.pre_id;

          this.$router.push({
            name: "anDetail",
            params: {
              id: id,
              item: item,
              nextid: res.data.data.pre_id,
              previd: res.data.data.next_id,
            },
          });
        }
      });
    },
    // 按钮
    upDrop() {
      if (!this.flag) {
        this.getMoreList();
        this.btn = "返回";
      } else {
        this.getList();
        this.btn = "显示更多";
      }
      this.flag = !this.flag;
    },
    // 初始显示的九条
    getList() {
      cases().then((res) => {
        if (res.data.code == 1) {
          // console.log(res.data.data);
          // 总条数
          this.total = res.data.data.length;
          var arr = res.data.data;
          var ninearr = arr.splice(0, 9);
          this.list = ninearr;
        }
      });
    },
    // 全部展示
    getMoreList() {
      cases().then((res) => {
        if (res.data.code == 1) {
          // console.log(res.data.data);
          // 总条数
          this.total = res.data.data.length;

          this.list = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.buy {
  font-family: 微软雅黑, MicrosoftYaHei;
  .intro {
    width: 1280px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .left {
      text-align: left;
    }
    .line {
      width: 90px;
      height: 8px;
    }
    .title {
      font-size: 42px;
      font-family: 微软雅黑, MicrosoftYaHei;
      font-weight: bold;
      color: #004c31;
      margin-top: 38px;
    }
    .subTitle {
      width: 168px;
      margin-top: 24px;
      font-size: 24px;
      font-weight: 400;
      color: #004c31;
    }
  }
  .btm {
    width: 100%;
    padding: 46px 0;
    background: #f5f5f5;
    .btmD {
      width: 1280px;
      margin: 0 auto;
      .jianjie {
        font-size: 20px;
        font-weight: 400;
        color: #6c7a77;
        line-height: 36px;
        text-align: left;
      }
      .itemWrap {
        margin-top: 75px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .item {
        width: 33%;
        border-right: 1px solid #c6cac9;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .itemnum {
          width: 208px;
          height: 66px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .itemTitle {
          margin-top: 34px;
          font-size: 20px;
          color: #004c31;
        }
      }
    }
  }
  .imgWrap {
    width: 1280px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .pic {
      flex-basis: 33%;
      position: relative;
      width: 420px;
      height: 253px;
      margin-top: 34px;
      img {
        width: 420px;
        height: 253px;
      }
      .mark {
        bottom: 0;
        left: 0;
        width: 354px;
        position: absolute;
        height: 52px;
        text-align: left;
        color: #fff;
        line-height: 52px;
        padding: 0 33px;
        background: #004c31;
      }
    }
  }
  .back {
    width: 172px;
    height: 53px;
    text-align: center;
    line-height: 53px;
    border: 1px solid #004c31;
    color: #004c31;
    margin: 64px auto 80px;
    &:hover {
      color: #fff;
      background: #004c31;
    }
  }
}
@media screen and (max-width: 450px) {
  .buy {
    font-family: 微软雅黑, MicrosoftYaHei;
    .intro {
      padding: 0 100px;
      width: auto;
      margin: 0 auto;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .left {
        text-align: left;
      }
      .line {
        width: 90 * 2px;
        height: 8 * 2px;
      }
      .title {
        font-size: 42 * 2px;
        font-family: 微软雅黑, MicrosoftYaHei;
        font-weight: bold;
        color: #004c31;
        margin-top: 38 * 2px;
      }
      .subTitle {
        width: 168 * 2px;
        margin-top: 24 * 2px;
        font-size: 24 * 2px;
        font-weight: 400;
        color: #004c31;
      }
    }
    .btm {
      width: 100%;
      padding: 46px 0;
      background: #f5f5f5;
      .btmD {
        width: auto;
        padding: 0 100px;
        margin: 0 auto;
        .jianjie {
          font-size: 20 * 2px;
          font-weight: 400;
          color: #6c7a77;
          line-height: unset;
          text-align: left;
        }
        .itemWrap {
          margin-top: 75 * 2px;
          display: flex;
          align-items: flex-start;
          justify-content: center;
        }
        .item {
          width: 35%;
          border-right: 1px solid #c6cac9;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .itemnum {
            width: 208 * 2px;
            height: 66 * 2px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .itemTitle {
            margin-top: 34 * 2px;
            font-size: 20 * 2px;
            color: #004c31;
          }
        }
      }
    }
    .imgWrap {
      padding: 0 100px;
      width: auto;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .pic {
        position: relative;
        width: 420 * 2px;
        height: 253 * 2px;
        margin-top: 34px;
        img {
          width: 420 * 2px;
          height: 253 * 2px;
        }
        .mark {
          bottom: 0;
          left: 0;
          width: 354 * 2px;
          position: absolute;
          height: 52 * 1.3px;
          text-align: left;
          color: #fff;
          line-height: 52px;
          padding: 0 33px;
          background: #004c31;
        }
      }
    }
    .back {
      width: 172 * 2px;
      height: 53 * 2px;
      text-align: center;
      line-height: 53 * 2px;
      border: 1px solid #004c31;
      color: #004c31;
      margin: 64 * 2px auto 80 * 2px;
      font-size: 42px;
      &:hover {
        color: #fff;
        background: #004c31;
      }
    }
  }
}
</style>
